import React from 'react'
import { ICharacter } from '../../../../../../../../api/types/character'
import { DiceRolls } from '../DiceRolls/DiceRolls'
import makeStyles from '@mui/styles/makeStyles'
import { Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    charName: {
      fontSize: '1.5em',
    },
    race: {
      fontStyle: 'italic',
    },
  })
)

interface Props {
  char: ICharacter
  game_id?: number
  showChatTab?: () => void
}

export const CharacterSheetHeader: React.FC<Props> = ({ char, game_id, showChatTab }) => {
  const classes = useStyles()

  return (
    <div className={classes.header}>
      <div>
        <div className={classes.charName}>{char.name}</div>
        <div className={classes.race}>{char.race.name}</div>
      </div>
      {game_id && <DiceRolls game_id={game_id} char={char} showChatTab={showChatTab} />}
    </div>
  )
}
